import clsx from 'clsx'
import {useCallback} from 'react'

import {Button} from '../button'
import {Link} from '../link'
import {Typography} from '../typography'
import {classes} from './classes'
import {NotificationAction} from './types'

type NotificationActionButtonProps = NotificationAction & {
  remove: VoidFunction
}

export const NotificationActionButton = (action: NotificationActionButtonProps) => {
  const handleClick = useCallback(() => {
    if ('callback' in action) action.callback()
    action.remove()
  }, [action])

  if (action.type === 'link') {
    return (
      <Link
        className={classes.expandedClickArea}
        href={action.to}
        onPress={action.remove}
        rel="noopener noreferer"
        target={action.external ? '_blank' : undefined}
      >
        <Typography color="invert" group="tight" variant="body2">
          {action.text}
        </Typography>
      </Link>
    )
  }

  return (
    <Button
      className={clsx(
        action.type === 'outline-lg' ? classes.actionBtnLg : classes.actionBtnSm,
        classes.expandedClickArea,
      )}
      onPress={handleClick}
      shape={action.type === 'outline-sm' ? 'circle' : 'squircle'}
      size={action.type === 'outline-lg' ? 'm' : 'xs'}
      variant="outline"
    >
      {action.text}
    </Button>
  )
}
